import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Card, Header} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import Loader from '../../../common/components/loader';
import {downloadFile} from '../../../common/util/file';
import AccountTable from './Table';
import './styles.scss';
const {navigateTo, getListAccountReport, downloadAccountReportList, clearDowloadAccountReportList} =
  Actions;
const AccountReporter = () => {
  const dowloadAccountReportWait = useSelector((state) => state.dowloadAccountReportWait);
  const vehiclesRaw = useSelector((state) => state.accountReportList.list);
  const loading = useSelector((state) => state.accountReportList.loading);
  const session = useSelector((state) => state.session);
  const dispatch = useDispatch();
  const {permissions} = session;
  const {url} = dowloadAccountReportWait;
  console.log(loading);
  useEffect(() => {
    if (!hasAccessPermission(permissions, resources.AccountList, scopes.See)) {
      dispatch(navigateTo(paths.AccessDenied));
    }
    dispatch(getListAccountReport());
  }, []);
  const handleDownloadList = () => {
    dispatch(downloadAccountReportList(vehiclesRaw));
  };

  useEffect(() => {
    if (url) {
      downloadFile(url);
      dispatch(clearDowloadAccountReportList());
    }
  }, [url, dispatch]);
   
  if (loading || dowloadAccountReportWait.loading) {
    return <Loader />;
  }
  return (
    <div>
      <Card raised fluid>
        <div className='container-vehicles-happy-wait pd'>
          <Header as='h2'>Estado de Cuenta</Header>
          <div className='pointer' onClick={handleDownloadList}>
            <img
              src={`${process.env.PUBLIC_URL}/icons/excel.svg`}
              alt='excel icon'
            />
          </div>
        </div>
      </Card>
      <Card raised fluid style={{'overflow': 'auto'}}>
        <AccountTable vehiclesRaw={vehiclesRaw} />
      </Card>
    </div>
  );
};

export default AccountReporter;
